/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Stack } from '../models/stack';
import { PageAbstractCluster } from '../models/page-abstract-cluster';
import { MigrateOverridesRequest } from '../models/migrate-overrides-request';
import { CreateProjectRequest } from '../models/create-project-request';
import { AbstractCluster } from '../models/abstract-cluster';
import { Substack } from '../models/substack';
import { SubstackRequest } from '../models/substack-request';
import { StackTemplate } from '../models/stack-template';
import { CreateBlueprintRequest } from '../models/create-blueprint-request';
import { ClusterMetadata } from '../models/cluster-metadata';
import { ClusterOverview } from '../models/cluster-overview';
import { EnableGitOpsRequest } from '../models/enable-git-ops-request';
import { DeploymentContext } from '../models/deployment-context';
import { Subscription } from '../models/subscription';
import { ClusterOverrideResponse } from '../models/cluster-override-response';
import { CreateTemplateRequest } from '../models/create-template-request';
import { SaveAsTemplateRequest } from '../models/save-as-template-request';
import { ToggleRelease } from '../models/toggle-release';

/**
 * Ui Stack Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiStackControllerService extends __BaseService {
  static readonly getStacksUsingGET1Path = '/cc-ui/v1/stacks/';
  static readonly createStackUsingPOST1Path = '/cc-ui/v1/stacks/';
  static readonly getAllClustersUsingGETPath = '/cc-ui/v1/stacks/clusters';
  static readonly migrateOverridesToGitUsingGETPath =
    '/cc-ui/v1/stacks/migrate-overrides';
  static readonly migrateOverridesToGitV2UsingPOSTPath =
    '/cc-ui/v1/stacks/migrate-overrides-v2';
  static readonly createProjectUsingPOSTPath = '/cc-ui/v1/stacks/project';
  static readonly getRunningBaseClustersUsingGETPath =
    '/cc-ui/v1/stacks/running-base-clusters';
  static readonly createStarterProjectUsingPOSTPath =
    '/cc-ui/v1/stacks/starter-project';
  static readonly createSubStackUsingPOSTPath =
    '/cc-ui/v1/stacks/substack/{substackName}';
  static readonly getStackTemplatesUsingGETPath = '/cc-ui/v1/stacks/templates';
  static readonly createStackV2UsingPOSTPath = '/cc-ui/v1/stacks/v2';
  static readonly getStackUsingGETPath = '/cc-ui/v1/stacks/{stackName}';
  static readonly updateStackUsingPUT1Path = '/cc-ui/v1/stacks/{stackName}';
  static readonly deleteStackUsingDELETEPath = '/cc-ui/v1/stacks/{stackName}';
  static readonly getClustersUsingGET1Path =
    '/cc-ui/v1/stacks/{stackName}/clusters';
  static readonly getClusterMetadataByStackUsingGETPath =
    '/cc-ui/v1/stacks/{stackName}/clusters-metadata';
  static readonly getClustersOverviewUsingGETPath =
    '/cc-ui/v1/stacks/{stackName}/clusters-overview';
  static readonly getClustersWithStatusUsingGETPath =
    '/cc-ui/v1/stacks/{stackName}/clustersWithStatus';
  static readonly enableGitOpsUsingPUTPath =
    '/cc-ui/v1/stacks/{stackName}/enable-git-ops';
  static readonly getLocalDeploymentContextUsingGETPath =
    '/cc-ui/v1/stacks/{stackName}/localDeploymentContext';
  static readonly getAllSubscriptionsUsingGET1Path =
    '/cc-ui/v1/stacks/{stackName}/notification/subscriptions';
  static readonly createSubscriptionUsingPOST1Path =
    '/cc-ui/v1/stacks/{stackName}/notification/subscriptions';
  static readonly reloadStackUsingGET1Path =
    '/cc-ui/v1/stacks/{stackName}/reload';
  static readonly getOverridesUsingGET2Path =
    '/cc-ui/v1/stacks/{stackName}/resourceType/{resourceType}/resourceName/{resourceName}/overrides';
  static readonly getResourceTypesUsingGETPath =
    '/cc-ui/v1/stacks/{stackName}/suggestions/resourceType';
  static readonly getResourcesByTypesUsingGETPath =
    '/cc-ui/v1/stacks/{stackName}/suggestions/resourceType/{resourceType}';
  static readonly syncResourcesUsingGETPath =
    '/cc-ui/v1/stacks/{stackName}/sync-resources';
  static readonly syncStackWithGitUsingGETPath =
    '/cc-ui/v1/stacks/{stackName}/sync-with-git';
  static readonly stackSyncWithGitUsingGETPath =
    '/cc-ui/v1/stacks/{stackName}/sync-with-git/v2';
  static readonly saveAsTemplateUsingPOSTPath =
    '/cc-ui/v1/stacks/{stackName}/template';
  static readonly saveAsTemplateV2UsingPOSTPath =
    '/cc-ui/v1/stacks/{stackName}/template-v2';
  static readonly getAllTemplateInputsMetaUsingGETPath =
    '/cc-ui/v1/stacks/{stackName}/templateInputs/meta';
  static readonly toggleReleaseUsingPOST1Path =
    '/cc-ui/v1/stacks/{stackName}/toggleRelease';
  static readonly getStackWithAccountUsingGETPath =
    '/cc-ui/v1/stacks/{stackName}/withAccount';
  static readonly getApplicationListUsingGETPath =
    '/cc-ui/v1/stacks/{stackName}/{resourceType}/';
  static readonly getApplicationUsingGET1Path =
    '/cc-ui/v1/stacks/{stackName}/{resourceType}/{appName}';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getStacks
   * @return OK
   */
  getStacksUsingGET1Response(): __Observable<
    __StrictHttpResponse<Array<Stack>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/stacks/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Stack>>;
      }),
    );
  }
  /**
   * getStacks
   * @return OK
   */
  getStacksUsingGET1(): __Observable<Array<Stack>> {
    return this.getStacksUsingGET1Response().pipe(
      __map((_r) => _r.body as Array<Stack>),
    );
  }

  /**
   * createStack
   * @param stack stack
   * @return OK
   */
  createStackUsingPOST1Response(
    stack: Stack,
  ): __Observable<__StrictHttpResponse<Stack>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = stack;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/stacks/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Stack>;
      }),
    );
  }
  /**
   * createStack
   * @param stack stack
   * @return OK
   */
  createStackUsingPOST1(stack: Stack): __Observable<Stack> {
    return this.createStackUsingPOST1Response(stack).pipe(
      __map((_r) => _r.body as Stack),
    );
  }

  /**
   * getAllClusters
   * @param params The `UiStackControllerService.GetAllClustersUsingGETParams` containing the following parameters:
   *
   * - `sortBy`: sortBy
   *
   * - `perPage`: perPage
   *
   * - `page`: page
   *
   * @return OK
   */
  getAllClustersUsingGETResponse(
    params: UiStackControllerService.GetAllClustersUsingGETParams,
  ): __Observable<__StrictHttpResponse<PageAbstractCluster>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.sortBy != null)
      __params = __params.set('sortBy', params.sortBy.toString());
    if (params.perPage != null)
      __params = __params.set('perPage', params.perPage.toString());
    if (params.page != null)
      __params = __params.set('page', params.page.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/stacks/clusters`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PageAbstractCluster>;
      }),
    );
  }
  /**
   * getAllClusters
   * @param params The `UiStackControllerService.GetAllClustersUsingGETParams` containing the following parameters:
   *
   * - `sortBy`: sortBy
   *
   * - `perPage`: perPage
   *
   * - `page`: page
   *
   * @return OK
   */
  getAllClustersUsingGET(
    params: UiStackControllerService.GetAllClustersUsingGETParams,
  ): __Observable<PageAbstractCluster> {
    return this.getAllClustersUsingGETResponse(params).pipe(
      __map((_r) => _r.body as PageAbstractCluster),
    );
  }

  /**
   * migrateOverridesToGit
   * @param stackName stackName
   */
  migrateOverridesToGitUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (stackName != null)
      __params = __params.set('stackName', stackName.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/stacks/migrate-overrides`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * migrateOverridesToGit
   * @param stackName stackName
   */
  migrateOverridesToGitUsingGET(stackName: string): __Observable<null> {
    return this.migrateOverridesToGitUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * migrateOverridesToGitV2
   * @param migrateOverridesRequest migrateOverridesRequest
   */
  migrateOverridesToGitV2UsingPOSTResponse(
    migrateOverridesRequest: MigrateOverridesRequest,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = migrateOverridesRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/stacks/migrate-overrides-v2`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * migrateOverridesToGitV2
   * @param migrateOverridesRequest migrateOverridesRequest
   */
  migrateOverridesToGitV2UsingPOST(
    migrateOverridesRequest: MigrateOverridesRequest,
  ): __Observable<null> {
    return this.migrateOverridesToGitV2UsingPOSTResponse(
      migrateOverridesRequest,
    ).pipe(__map((_r) => _r.body as null));
  }

  /**
   * createProject
   * @param request request
   * @return OK
   */
  createProjectUsingPOSTResponse(
    request: CreateProjectRequest,
  ): __Observable<__StrictHttpResponse<Stack>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/stacks/project`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Stack>;
      }),
    );
  }
  /**
   * createProject
   * @param request request
   * @return OK
   */
  createProjectUsingPOST(request: CreateProjectRequest): __Observable<Stack> {
    return this.createProjectUsingPOSTResponse(request).pipe(
      __map((_r) => _r.body as Stack),
    );
  }

  /**
   * getRunningBaseClusters
   * @return OK
   */
  getRunningBaseClustersUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<AbstractCluster>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/stacks/running-base-clusters`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AbstractCluster>>;
      }),
    );
  }
  /**
   * getRunningBaseClusters
   * @return OK
   */
  getRunningBaseClustersUsingGET(): __Observable<Array<AbstractCluster>> {
    return this.getRunningBaseClustersUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<AbstractCluster>),
    );
  }

  /**
   * createStarterProject
   * @return OK
   */
  createStarterProjectUsingPOSTResponse(): __Observable<
    __StrictHttpResponse<Stack>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/stacks/starter-project`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Stack>;
      }),
    );
  }
  /**
   * createStarterProject
   * @return OK
   */
  createStarterProjectUsingPOST(): __Observable<Stack> {
    return this.createStarterProjectUsingPOSTResponse().pipe(
      __map((_r) => _r.body as Stack),
    );
  }

  /**
   * createSubStack
   * @param params The `UiStackControllerService.CreateSubStackUsingPOSTParams` containing the following parameters:
   *
   * - `substackName`: substackName
   *
   * - `subStack`: subStack
   *
   * @return OK
   */
  createSubStackUsingPOSTResponse(
    params: UiStackControllerService.CreateSubStackUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<Substack>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.subStack;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/stacks/substack/${encodeURIComponent(
          String(params.substackName),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Substack>;
      }),
    );
  }
  /**
   * createSubStack
   * @param params The `UiStackControllerService.CreateSubStackUsingPOSTParams` containing the following parameters:
   *
   * - `substackName`: substackName
   *
   * - `subStack`: subStack
   *
   * @return OK
   */
  createSubStackUsingPOST(
    params: UiStackControllerService.CreateSubStackUsingPOSTParams,
  ): __Observable<Substack> {
    return this.createSubStackUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as Substack),
    );
  }

  /**
   * getStackTemplates
   * @return OK
   */
  getStackTemplatesUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<StackTemplate>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/stacks/templates`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<StackTemplate>>;
      }),
    );
  }
  /**
   * getStackTemplates
   * @return OK
   */
  getStackTemplatesUsingGET(): __Observable<Array<StackTemplate>> {
    return this.getStackTemplatesUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<StackTemplate>),
    );
  }

  /**
   * createStackV2
   * @param createBlueprintRequest createBlueprintRequest
   * @return OK
   */
  createStackV2UsingPOSTResponse(
    createBlueprintRequest: CreateBlueprintRequest,
  ): __Observable<__StrictHttpResponse<Stack>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = createBlueprintRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/stacks/v2`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Stack>;
      }),
    );
  }
  /**
   * createStackV2
   * @param createBlueprintRequest createBlueprintRequest
   * @return OK
   */
  createStackV2UsingPOST(
    createBlueprintRequest: CreateBlueprintRequest,
  ): __Observable<Stack> {
    return this.createStackV2UsingPOSTResponse(createBlueprintRequest).pipe(
      __map((_r) => _r.body as Stack),
    );
  }

  /**
   * getStack
   * @param stackName stackName
   * @return OK
   */
  getStackUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Stack>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(String(stackName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Stack>;
      }),
    );
  }
  /**
   * getStack
   * @param stackName stackName
   * @return OK
   */
  getStackUsingGET(stackName: string): __Observable<Stack> {
    return this.getStackUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as Stack),
    );
  }

  /**
   * updateStack
   * @param params The `UiStackControllerService.UpdateStackUsingPUT1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `stack`: stack
   *
   * @return OK
   */
  updateStackUsingPUT1Response(
    params: UiStackControllerService.UpdateStackUsingPUT1Params,
  ): __Observable<__StrictHttpResponse<Stack>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.stack;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(String(params.stackName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Stack>;
      }),
    );
  }
  /**
   * updateStack
   * @param params The `UiStackControllerService.UpdateStackUsingPUT1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `stack`: stack
   *
   * @return OK
   */
  updateStackUsingPUT1(
    params: UiStackControllerService.UpdateStackUsingPUT1Params,
  ): __Observable<Stack> {
    return this.updateStackUsingPUT1Response(params).pipe(
      __map((_r) => _r.body as Stack),
    );
  }

  /**
   * deleteStack
   * @param stackName stackName
   * @return OK
   */
  deleteStackUsingDELETEResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Stack>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(String(stackName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Stack>;
      }),
    );
  }
  /**
   * deleteStack
   * @param stackName stackName
   * @return OK
   */
  deleteStackUsingDELETE(stackName: string): __Observable<Stack> {
    return this.deleteStackUsingDELETEResponse(stackName).pipe(
      __map((_r) => _r.body as Stack),
    );
  }

  /**
   * getClusters
   * @param stackName stackName
   * @return OK
   */
  getClustersUsingGET1Response(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Array<AbstractCluster>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(String(stackName))}/clusters`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AbstractCluster>>;
      }),
    );
  }
  /**
   * getClusters
   * @param stackName stackName
   * @return OK
   */
  getClustersUsingGET1(
    stackName: string,
  ): __Observable<Array<AbstractCluster>> {
    return this.getClustersUsingGET1Response(stackName).pipe(
      __map((_r) => _r.body as Array<AbstractCluster>),
    );
  }

  /**
   * getClusterMetadataByStack
   * @param stackName stackName
   * @return OK
   */
  getClusterMetadataByStackUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Array<ClusterMetadata>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(stackName),
        )}/clusters-metadata`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ClusterMetadata>>;
      }),
    );
  }
  /**
   * getClusterMetadataByStack
   * @param stackName stackName
   * @return OK
   */
  getClusterMetadataByStackUsingGET(
    stackName: string,
  ): __Observable<Array<ClusterMetadata>> {
    return this.getClusterMetadataByStackUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as Array<ClusterMetadata>),
    );
  }

  /**
   * getClustersOverview
   * @param stackName stackName
   * @return OK
   */
  getClustersOverviewUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Array<ClusterOverview>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(stackName),
        )}/clusters-overview`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ClusterOverview>>;
      }),
    );
  }
  /**
   * getClustersOverview
   * @param stackName stackName
   * @return OK
   */
  getClustersOverviewUsingGET(
    stackName: string,
  ): __Observable<Array<ClusterOverview>> {
    return this.getClustersOverviewUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as Array<ClusterOverview>),
    );
  }

  /**
   * getClustersWithStatus
   * @param stackName stackName
   * @return OK
   */
  getClustersWithStatusUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Array<AbstractCluster>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(stackName),
        )}/clustersWithStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AbstractCluster>>;
      }),
    );
  }
  /**
   * getClustersWithStatus
   * @param stackName stackName
   * @return OK
   */
  getClustersWithStatusUsingGET(
    stackName: string,
  ): __Observable<Array<AbstractCluster>> {
    return this.getClustersWithStatusUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as Array<AbstractCluster>),
    );
  }

  /**
   * enableGitOps
   * @param params The `UiStackControllerService.EnableGitOpsUsingPUTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `request`: request
   *
   * @return OK
   */
  enableGitOpsUsingPUTResponse(
    params: UiStackControllerService.EnableGitOpsUsingPUTParams,
  ): __Observable<__StrictHttpResponse<Stack>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(params.stackName),
        )}/enable-git-ops`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Stack>;
      }),
    );
  }
  /**
   * enableGitOps
   * @param params The `UiStackControllerService.EnableGitOpsUsingPUTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `request`: request
   *
   * @return OK
   */
  enableGitOpsUsingPUT(
    params: UiStackControllerService.EnableGitOpsUsingPUTParams,
  ): __Observable<Stack> {
    return this.enableGitOpsUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as Stack),
    );
  }

  /**
   * getLocalDeploymentContext
   * @param stackName stackName
   * @return OK
   */
  getLocalDeploymentContextUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<DeploymentContext>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(stackName),
        )}/localDeploymentContext`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DeploymentContext>;
      }),
    );
  }
  /**
   * getLocalDeploymentContext
   * @param stackName stackName
   * @return OK
   */
  getLocalDeploymentContextUsingGET(
    stackName: string,
  ): __Observable<DeploymentContext> {
    return this.getLocalDeploymentContextUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as DeploymentContext),
    );
  }

  /**
   * getAllSubscriptions
   * @param stackName stackName
   * @return OK
   */
  getAllSubscriptionsUsingGET1Response(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Array<Subscription>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(stackName),
        )}/notification/subscriptions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Subscription>>;
      }),
    );
  }
  /**
   * getAllSubscriptions
   * @param stackName stackName
   * @return OK
   */
  getAllSubscriptionsUsingGET1(
    stackName: string,
  ): __Observable<Array<Subscription>> {
    return this.getAllSubscriptionsUsingGET1Response(stackName).pipe(
      __map((_r) => _r.body as Array<Subscription>),
    );
  }

  /**
   * createSubscription
   * @param params The `UiStackControllerService.CreateSubscriptionUsingPOST1Params` containing the following parameters:
   *
   * - `subscription`: subscription
   *
   * - `stackName`: stackName
   *
   * @return OK
   */
  createSubscriptionUsingPOST1Response(
    params: UiStackControllerService.CreateSubscriptionUsingPOST1Params,
  ): __Observable<__StrictHttpResponse<Subscription>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.subscription;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(params.stackName),
        )}/notification/subscriptions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Subscription>;
      }),
    );
  }
  /**
   * createSubscription
   * @param params The `UiStackControllerService.CreateSubscriptionUsingPOST1Params` containing the following parameters:
   *
   * - `subscription`: subscription
   *
   * - `stackName`: stackName
   *
   * @return OK
   */
  createSubscriptionUsingPOST1(
    params: UiStackControllerService.CreateSubscriptionUsingPOST1Params,
  ): __Observable<Subscription> {
    return this.createSubscriptionUsingPOST1Response(params).pipe(
      __map((_r) => _r.body as Subscription),
    );
  }

  /**
   * reloadStack
   * @param stackName stackName
   * @return OK
   */
  reloadStackUsingGET1Response(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Stack>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(String(stackName))}/reload`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Stack>;
      }),
    );
  }
  /**
   * reloadStack
   * @param stackName stackName
   * @return OK
   */
  reloadStackUsingGET1(stackName: string): __Observable<Stack> {
    return this.reloadStackUsingGET1Response(stackName).pipe(
      __map((_r) => _r.body as Stack),
    );
  }

  /**
   * getOverrides
   * @param params The `UiStackControllerService.GetOverridesUsingGET2Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  getOverridesUsingGET2Response(
    params: UiStackControllerService.GetOverridesUsingGET2Params,
  ): __Observable<__StrictHttpResponse<Array<ClusterOverrideResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(params.stackName),
        )}/resourceType/${encodeURIComponent(
          String(params.resourceType),
        )}/resourceName/${encodeURIComponent(
          String(params.resourceName),
        )}/overrides`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ClusterOverrideResponse>>;
      }),
    );
  }
  /**
   * getOverrides
   * @param params The `UiStackControllerService.GetOverridesUsingGET2Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  getOverridesUsingGET2(
    params: UiStackControllerService.GetOverridesUsingGET2Params,
  ): __Observable<Array<ClusterOverrideResponse>> {
    return this.getOverridesUsingGET2Response(params).pipe(
      __map((_r) => _r.body as Array<ClusterOverrideResponse>),
    );
  }

  /**
   * getResourceTypes
   * @param stackName stackName
   * @return OK
   */
  getResourceTypesUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(stackName),
        )}/suggestions/resourceType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getResourceTypes
   * @param stackName stackName
   * @return OK
   */
  getResourceTypesUsingGET(stackName: string): __Observable<Array<string>> {
    return this.getResourceTypesUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }

  /**
   * getResourcesByTypes
   * @param params The `UiStackControllerService.GetResourcesByTypesUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * @return OK
   */
  getResourcesByTypesUsingGETResponse(
    params: UiStackControllerService.GetResourcesByTypesUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(params.stackName),
        )}/suggestions/resourceType/${encodeURIComponent(
          String(params.resourceType),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getResourcesByTypes
   * @param params The `UiStackControllerService.GetResourcesByTypesUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * @return OK
   */
  getResourcesByTypesUsingGET(
    params: UiStackControllerService.GetResourcesByTypesUsingGETParams,
  ): __Observable<Array<string>> {
    return this.getResourcesByTypesUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }

  /**
   * syncResources
   * @param stackName stackName
   */
  syncResourcesUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(stackName),
        )}/sync-resources`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * syncResources
   * @param stackName stackName
   */
  syncResourcesUsingGET(stackName: string): __Observable<null> {
    return this.syncResourcesUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * syncStackWithGit
   * @param stackName stackName
   */
  syncStackWithGitUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(stackName),
        )}/sync-with-git`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * syncStackWithGit
   * @param stackName stackName
   */
  syncStackWithGitUsingGET(stackName: string): __Observable<null> {
    return this.syncStackWithGitUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * Sync stack with git
   *
   * Use this to sync stack with git. Runs synchronously for the stack, and then does a non-force sync of all clusters in async
   * @param stackName stackName
   */
  stackSyncWithGitUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(stackName),
        )}/sync-with-git/v2`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * Sync stack with git
   *
   * Use this to sync stack with git. Runs synchronously for the stack, and then does a non-force sync of all clusters in async
   * @param stackName stackName
   */
  stackSyncWithGitUsingGET(stackName: string): __Observable<null> {
    return this.stackSyncWithGitUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * saveAsTemplate
   * @param params The `UiStackControllerService.SaveAsTemplateUsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `createTemplateRequest`: createTemplateRequest
   *
   * @return OK
   */
  saveAsTemplateUsingPOSTResponse(
    params: UiStackControllerService.SaveAsTemplateUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<Stack>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.createTemplateRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(params.stackName),
        )}/template`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Stack>;
      }),
    );
  }
  /**
   * saveAsTemplate
   * @param params The `UiStackControllerService.SaveAsTemplateUsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `createTemplateRequest`: createTemplateRequest
   *
   * @return OK
   */
  saveAsTemplateUsingPOST(
    params: UiStackControllerService.SaveAsTemplateUsingPOSTParams,
  ): __Observable<Stack> {
    return this.saveAsTemplateUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as Stack),
    );
  }

  /**
   * saveAsTemplateV2
   * @param params The `UiStackControllerService.SaveAsTemplateV2UsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `saveAsTemplateRequest`: saveAsTemplateRequest
   *
   * @return OK
   */
  saveAsTemplateV2UsingPOSTResponse(
    params: UiStackControllerService.SaveAsTemplateV2UsingPOSTParams,
  ): __Observable<__StrictHttpResponse<Stack>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.saveAsTemplateRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(params.stackName),
        )}/template-v2`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Stack>;
      }),
    );
  }
  /**
   * saveAsTemplateV2
   * @param params The `UiStackControllerService.SaveAsTemplateV2UsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `saveAsTemplateRequest`: saveAsTemplateRequest
   *
   * @return OK
   */
  saveAsTemplateV2UsingPOST(
    params: UiStackControllerService.SaveAsTemplateV2UsingPOSTParams,
  ): __Observable<Stack> {
    return this.saveAsTemplateV2UsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as Stack),
    );
  }

  /**
   * getAllTemplateInputsMeta
   * @param stackName stackName
   * @return OK
   */
  getAllTemplateInputsMetaUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(stackName),
        )}/templateInputs/meta`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      }),
    );
  }
  /**
   * getAllTemplateInputsMeta
   * @param stackName stackName
   * @return OK
   */
  getAllTemplateInputsMetaUsingGET(stackName: string): __Observable<{}> {
    return this.getAllTemplateInputsMetaUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as {}),
    );
  }

  /**
   * toggleRelease
   * @param params The `UiStackControllerService.ToggleReleaseUsingPOST1Params` containing the following parameters:
   *
   * - `toggleRelease`: toggleRelease
   *
   * - `stackName`: stackName
   *
   * @return OK
   */
  toggleReleaseUsingPOST1Response(
    params: UiStackControllerService.ToggleReleaseUsingPOST1Params,
  ): __Observable<__StrictHttpResponse<ToggleRelease>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.toggleRelease;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(params.stackName),
        )}/toggleRelease`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ToggleRelease>;
      }),
    );
  }
  /**
   * toggleRelease
   * @param params The `UiStackControllerService.ToggleReleaseUsingPOST1Params` containing the following parameters:
   *
   * - `toggleRelease`: toggleRelease
   *
   * - `stackName`: stackName
   *
   * @return OK
   */
  toggleReleaseUsingPOST1(
    params: UiStackControllerService.ToggleReleaseUsingPOST1Params,
  ): __Observable<ToggleRelease> {
    return this.toggleReleaseUsingPOST1Response(params).pipe(
      __map((_r) => _r.body as ToggleRelease),
    );
  }

  /**
   * getStackWithAccount
   * @param stackName stackName
   * @return OK
   */
  getStackWithAccountUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Stack>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(String(stackName))}/withAccount`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Stack>;
      }),
    );
  }
  /**
   * getStackWithAccount
   * @param stackName stackName
   * @return OK
   */
  getStackWithAccountUsingGET(stackName: string): __Observable<Stack> {
    return this.getStackWithAccountUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as Stack),
    );
  }

  /**
   * getApplicationList
   * @param params The `UiStackControllerService.GetApplicationListUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * @return OK
   */
  getApplicationListUsingGETResponse(
    params: UiStackControllerService.GetApplicationListUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(params.stackName),
        )}/${encodeURIComponent(String(params.resourceType))}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getApplicationList
   * @param params The `UiStackControllerService.GetApplicationListUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * @return OK
   */
  getApplicationListUsingGET(
    params: UiStackControllerService.GetApplicationListUsingGETParams,
  ): __Observable<Array<string>> {
    return this.getApplicationListUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }

  /**
   * getApplication
   * @param params The `UiStackControllerService.GetApplicationUsingGET1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `appName`: appName
   *
   * @return OK
   */
  getApplicationUsingGET1Response(
    params: UiStackControllerService.GetApplicationUsingGET1Params,
  ): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/stacks/${encodeURIComponent(
          String(params.stackName),
        )}/${encodeURIComponent(
          String(params.resourceType),
        )}/${encodeURIComponent(String(params.appName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      }),
    );
  }
  /**
   * getApplication
   * @param params The `UiStackControllerService.GetApplicationUsingGET1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `appName`: appName
   *
   * @return OK
   */
  getApplicationUsingGET1(
    params: UiStackControllerService.GetApplicationUsingGET1Params,
  ): __Observable<{}> {
    return this.getApplicationUsingGET1Response(params).pipe(
      __map((_r) => _r.body as {}),
    );
  }
}

module UiStackControllerService {
  /**
   * Parameters for getAllClustersUsingGET
   */
  export interface GetAllClustersUsingGETParams {
    /**
     * sortBy
     */
    sortBy?:
      | 'ID'
      | 'CREATION_DATE'
      | 'CREATED_BY'
      | 'LAST_MODIFIED_DATE'
      | 'LAST_MODIFIED_BY';

    /**
     * perPage
     */
    perPage?: number;

    /**
     * page
     */
    page?: number;
  }

  /**
   * Parameters for createSubStackUsingPOST
   */
  export interface CreateSubStackUsingPOSTParams {
    /**
     * substackName
     */
    substackName: string;

    /**
     * subStack
     */
    subStack: SubstackRequest;
  }

  /**
   * Parameters for updateStackUsingPUT1
   */
  export interface UpdateStackUsingPUT1Params {
    /**
     * stackName
     */
    stackName: string;

    /**
     * stack
     */
    stack: Stack;
  }

  /**
   * Parameters for enableGitOpsUsingPUT
   */
  export interface EnableGitOpsUsingPUTParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * request
     */
    request: EnableGitOpsRequest;
  }

  /**
   * Parameters for createSubscriptionUsingPOST1
   */
  export interface CreateSubscriptionUsingPOST1Params {
    /**
     * subscription
     */
    subscription: Subscription;

    /**
     * stackName
     */
    stackName: string;
  }

  /**
   * Parameters for getOverridesUsingGET2
   */
  export interface GetOverridesUsingGET2Params {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;
  }

  /**
   * Parameters for getResourcesByTypesUsingGET
   */
  export interface GetResourcesByTypesUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;
  }

  /**
   * Parameters for saveAsTemplateUsingPOST
   */
  export interface SaveAsTemplateUsingPOSTParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * createTemplateRequest
     */
    createTemplateRequest: CreateTemplateRequest;
  }

  /**
   * Parameters for saveAsTemplateV2UsingPOST
   */
  export interface SaveAsTemplateV2UsingPOSTParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * saveAsTemplateRequest
     */
    saveAsTemplateRequest: SaveAsTemplateRequest;
  }

  /**
   * Parameters for toggleReleaseUsingPOST1
   */
  export interface ToggleReleaseUsingPOST1Params {
    /**
     * toggleRelease
     */
    toggleRelease: ToggleRelease;

    /**
     * stackName
     */
    stackName: string;
  }

  /**
   * Parameters for getApplicationListUsingGET
   */
  export interface GetApplicationListUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;
  }

  /**
   * Parameters for getApplicationUsingGET1
   */
  export interface GetApplicationUsingGET1Params {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * appName
     */
    appName: string;
  }
}

export { UiStackControllerService };
